<div class="acc-content mgbtm" *ngIf="isWSSBLP;else firststepvalidation">  
  <div class="row xsmbt0" style="margin-top:30px">
    <div class="col-100">
      <div class="cst-input-field medium input-with-icn mb-1">
        <label translate>lblEnterRegNoOrVinNo</label>
      </div>
    </div>
    <div class="col-50 xscol-100 mbt15">
      <div class="cst-input-field big input-with-icn">
        <div class="lic-plate pos-relative">
          <em class="cmn-icn icn-flag  " [ngClass]="licensePlateClass"></em>
          <input type="text" id="regNo" class="pdl60 bold fs20px" [(ngModel)]="vehicleNo" (ngModelChange)="vehicleNo = $event.toUpperCase()" [appAutoFocus] (keyup.enter)="showVehicleDetails(true)">
          <button type="button" class="btn btn-primary m-1" translate (click)="showVehicleDetails(true)">
            lblSearch
          </button>
        </div>

      </div>
    </div>
    <div class="col-auto xscol-100 mbt15 top-margin text-right">
       <button type="button" class="btn btn btn-primary mt-2" translate (click)="showVehicleDetails(false)" >
        lblAddCarManually
      </button>
    </div>
    <div class="col-100">
      <div class="hr-lineborder"></div>
    </div>
  </div>
  <form #PhoneNumberForm="ngForm" *ngIf="isshowmobilenumber"> 
      <div class="row xsmbt20">
      <div class="col-50 xscol-100 smcol-50 mdcol-50">
        <div class="cst-input-field big input-with-icn mbt20">
          <label translate class="label-big mbt10 dis-blk cstsp" for="mobileNo">
            lblEnterMobileNumber<strong class="required mlt6">*</strong>
          </label>
          <div class="pos-relative lic-plate overflow-visible">
            <ngx-intl-tel-input [selectFirstCountry]= "false" inputId="mobileNo" [cssClass]="{'form-control': true}"
                        [selectedCountryISO]="selectedCountryISO" [maxLength]="11" [phoneValidation]="false" name="mobileNo"
                        [separateDialCode]="true" [onlyCountries]="onlyCountries" [enablePlaceholder]="false"
                        [(ngModel)]="mobileNumber" #mobileNo="ngModel" (countryChange)="onForgetCountryChange($event)"
                        (keyup.enter)="onMobileNoEnter__WCVLS()" (ngModelChange)="onchange($event,PhoneNumberForm)" required></ngx-intl-tel-input>

            <button translate type="submit" aria-label="Center Align" class="btn mainbtn btn-primary mr-1"
              id="showForgetRegOtp" (click)="onMobileNoEnter__WCVLS()">
              lblNext <em class="fa fa-angle-right right-10 font-18 mobile-next-arrow"></em>
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
  <div *ngIf="isshowOTP" id="forgetRegOtpSection">
    <div class="mbt20">
      <p translate class="font18 mbt10"><strong translate>lblConfirmYourIdentity</strong></p>
      <p translate class="font16">lblEnterCodeYouReceivedOnSMSToConfirm</p>
    </div>

    <div class="row xsmbt0">
      <div class="col-30 xscol-100 smcol-40 xsmbt15 smmbt40">
        <div class="cst-input-field">
          <label translate class="label-big" for="otp">lblEnterCode</label>
          <div class="pos-rel">
            <input type="text" id="OTPInput" name="OTPInput" class="form-control" required (keypress)="isDigit($event)"
              [(ngModel)]="OTP" minlength="6" maxlength="6" #OTPInput="ngModel" [appAutoFocus]
              (keyup.enter)="onOTPSubmit_WCVLS()" />
          </div>
        </div>
      </div>
      <div class="col-50 xscol-100 smcol-60 search-cont xsmbt10">
        <div class="btn-grp mb xsfright">
          <button translate type="submit" aria-label="Center Align" class="btn btn-primary" id="showCarSelectionDouble"
            (click)="onOTPSubmit_WCVLS()" [disabled]="!OTPInput.valid">
            lblConfirm
          </button>
          <button translate type="button" aria-label="Center Align" class="btn btn-secondary"
            (click)="onChangePhoneNo_WCVLS()">
            lblChangeThePhoneNumber
          </button>
        </div>
      </div>
      <div translate class="col-100 xsrel mgtop">
        <div class="d-block">
          <span class="d-sm-block">
            <a href="javascript:void(0);" *ngIf="!timeout" class="font16 disabled">
              <span translate class="mrt10 xsmrt5 text-underline">lblResendOTP</span></a>
            <a href="javascript:void(0);" *ngIf="timeout" class="clrblue font16 togglelink" (click)="ResendOTP()">
              <span translate class="mrt10 xsmrt5 text-underline">lblResendOTP</span></a>
            <div class="clrgreen">{{otpTimer}}</div>
            &nbsp;<span class="success-msg p-2" *ngIf="successMsg">
              <em class="fa fa-check"></em>
              <span translate>lblOTPIsSentSuccessfully</span>
            </span>
          </span>
        </div>
        <div class="d-block mt-2 pt10 mob-font11">
          <span> <span translate>lblOTPHasBeenSentToYourMobileNumber</span> : +{{userForgotAuthMobilecode}}</span>
          {{mobileNumber.number}}
          &nbsp;
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #firststepvalidation> 
<div class="acc-content mgbtm">
  <div class="d-none" *ngIf="sections.registrationNumberSection" id="regNoSection">
    <form #registrationNumberForm="ngForm" (ngSubmit)="onRegistrationNumberFormSubmit(registrationNumberForm)"
      class="row xsblock smblock no-bt-border">
      <div class="smcol-60 xsmbt10 smmbt20 mdcol-80 col-80 mtp10">
        <div class="cst-input-field big input-with-icn">
          <label translate class="label-big mbt10 dis-blk cstsp" for="registrationNumber">
            lblRegNumber<strong class="required mlt6">*</strong>
          </label>
          <div class="lic-plate pos-relative">
            <em class="cmn-icn icn-flag " [ngClass]="licensePlateClass"></em>
            <input type="text" id="registrationNumber" class="pdl70" name="registrationNumber" maxlength="10"
              [(ngModel)]="licensePlate" (ngModelChange)="licensePlate = $event.toUpperCase()"
              #registrationNumber="ngModel" pattern="^[A-Za-z0-9 ]*$" required />
            <button type="submit" aria-label="Center Align" class="btn mainbtn btn-primary"
              (click)="validateLicensePlateField(registrationNumberForm.valid)">
              <span translate class="ng-binding">lblNext</span>
              <em class="pos-relative font18 fa fa-angle-right ml-2"></em>
            </button>
          </div>
        </div>
        <div class="linkst1 flex-center forgetlink mtp15 cstsp" (click)="onForgotRegistrationNumber()"
          id="showForgetRegPhoneNumber"><span translate>lblForgotYourRegistrationNumber</span>?
        </div>
      </div>
    </form>
  </div>
  <div id="forgetRegPhoneNumberSection">
    <form #forgetRegPhoneNumberForm="ngForm">
      <div class="row mtp10 mbt20 mb-3">
        <div translate class="col-12">
          <div translate class="welcome-msg" *ngIf="!hideMobileNo && !sections.carSelectionSingle">
            lblEnterMobileNumberToReceiveASecurityCode
          </div>
        </div>
      </div>
      <div class="row xsmbt20" *ngIf="!hideMobileNo && !sections.carSelectionSingle">
        <div class="col-50 xscol-100 smcol-50 mdcol-50">
          <div class="cst-input-field big input-with-icn mbt20">
            <label translate class="label-big mbt10 dis-blk cstsp" for="mobileNo">
              lblEnterMobileNumber<strong class="required mlt6">*</strong>
            </label>
            <div class="pos-relative lic-plate overflow-visible">
              <ngx-intl-tel-input [selectFirstCountry]= "false" inputId="mobileNo" [cssClass]="{'form-control': true}"
                        [selectedCountryISO]="selectedCountryISO" [maxLength]="15" [phoneValidation]="true" name="mobileNo"
                        [separateDialCode]="true" [onlyCountries]="onlyCountries" [enablePlaceholder]="false"
                        [(ngModel)]="mobileNumber" #mobileNo="ngModel" (countryChange)="onForgetCountryChange($event)"
                        (input)="onchange($event,forgetRegPhoneNumberForm)"
                        (keypress)="isDigit($event)" (ngModelChange)="changeMobile()" (keyup.enter)="onMobileNoEnter()" required></ngx-intl-tel-input>

              <button translate type="submit" aria-label="Center Align" class="btn mainbtn btn-primary mr-1"
                id="showForgetRegOtp" (click)="onMobileNoEnter()">
                lblNext <em class="fa fa-angle-right right-10 font-18 mobile-next-arrow"></em>
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div *ngIf="showTempOTPSection" id="forgetRegOtpSection">
    <div class="mbt20">
      <p translate class="font18 mbt10"><strong translate>lblConfirmYourIdentity</strong></p>
      <p translate class="font16">lblEnterCodeYouReceivedOnSMSToConfirm</p>
    </div>

    <div class="row xsmbt0">
      <div class="col-30 xscol-100 smcol-40 xsmbt15 smmbt40">
        <div class="cst-input-field">
          <label translate class="label-big" for="otp">lblEnterCode</label>
          <div class="pos-rel">
            <input type="text" id="OTPInput" name="OTPInput" class="form-control" required (keypress)="isDigit($event)"
              [(ngModel)]="OTP" minlength="6" maxlength="6" #OTPInput="ngModel" [appAutoFocus]
              (keyup.enter)="onOTPSubmit()" />
          </div>
        </div>
      </div>
      <div class="col-50 xscol-100 smcol-60 search-cont xsmbt10">
        <div class="btn-grp mb xsfright">
          <button translate type="submit" aria-label="Center Align" class="btn btn-primary" id="showCarSelectionDouble"
            (click)="onOTPSubmit()" [disabled]="!OTPInput.valid">
            lblConfirm
          </button>
          <button translate type="button" aria-label="Center Align" class="btn btn-secondary"
            (click)="onChangePhoneNo()">
            lblChangeThePhoneNumber
          </button>
        </div>
      </div>
      <div translate class="col-100 xsrel mgtop">
        <div class="d-block">
          <span class="d-sm-block">
            <a href="javascript:void(0);" *ngIf="!timeout" class="font16 disabled">
              <span translate class="mrt10 xsmrt5 text-underline">lblResendOTP</span></a>
            <a href="javascript:void(0);" *ngIf="timeout" class="clrblue font16 togglelink" (click)="ResendOTP()">
              <span translate class="mrt10 xsmrt5 text-underline">lblResendOTP</span></a>
            <div class="clrgreen">{{otpTimer}}</div>
            &nbsp;<span class="success-msg p-2" *ngIf="successMsg">
              <em class="fa fa-check"></em>
              <span translate>lblOTPIsSentSuccessfully</span>
            </span>
          </span>
        </div>
        <div class="d-block mt-2 pt10 mob-font11">
          <span> <span translate>lblOTPHasBeenSentToYourMobileNumber</span> : +{{userForgotAuthMobilecode}}</span>
          {{mobileNumber.number}}
          &nbsp;
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="sections.forgetRegOtpSection" id="forgetRegOtpSection">
    <div class="mbt20">
      <p translate class="font18 mbt10"><strong translate>lblConfirmYourIdentity</strong></p>
      <p translate class="font16">lblEnterCodeYouReceivedOnSMSToConfirm</p>
    </div>

    <div class="row xsmbt0 align-items-end">
        <div class="col-12 col-md-5 d-flex pr-0 pr-md-2">
          <div class="cst-input-field flex1 align-items-end">
            <label translate class="label-big" for="otp">lblEnterCode</label>
            <div class="pos-rel">
              <input type="text" id="OTPInput" name="OTPInput" class="form-control" required (keypress)="isDigit($event)" [(ngModel)]="OTP" minlength="6" maxlength="6" #OTPInput="ngModel" [appAutoFocus] (keyup.enter)="onOTPSubmit()"/>
            </div>
            
          </div>
          <div class="d-flex align-items-end">
            <button translate type="submit" aria-label="Center Align" class="btn btn-primary ml-2" id="showCarSelectionDouble" (click)="onOTPSubmit()"
            [disabled]="!OTPInput.valid">
            lblConfirm
          </button>
          </div>
          
        </div>
        <div class="col-12 col-md-7 mt-2 mt-md-0 pl-sm-0 pl-md-2">
          <div class="btn-grp">
            
            <button translate type="button" aria-label="Center Align" class="btn btn-secondary w-sm-100"
              (click)="onChangePhoneNo()">
              lblChangeThePhoneNumber
            </button>
          </div>
        </div>
        <div translate class="col-12 mt-2">
          <div class="d-block">
            <span class="d-sm-block">
            <a href="javascript:void(0);" *ngIf="!timeout" class="font16 disabled">
              <span translate class="mrt10 xsmrt5 text-underline">lblResendOTP</span></a>
            <a href="javascript:void(0);" *ngIf="timeout" class="clrblue font16 togglelink" (click)="ResendOTP()">
              <span translate class="mrt10 xsmrt5 text-underline">lblResendOTP</span></a>
            <span class="clrgreen">{{otpTimer}}</span>
            &nbsp;<span class="success-msg p-2" *ngIf="successMsg">
              <em class="fa fa-check"></em>
              <span translate>lblOTPIsSentSuccessfully</span>
            </span>
          </span>
        </div>
        <div class="d-block mt-2 pt10 mob-font11">
          <span> <span translate>lblOTPHasBeenSentToYourMobileNumber</span> : +{{userForgotAuthMobilecode}}</span>
          {{mobileNumber.number}}
          &nbsp;
        </div>
      </div>
    </div>
  </div>

  <!-- CCARLIST-->
  <div class="pos-relative mtp-70 xs-mtp20" *ngIf="sections.carSelectionSingle && !showTempOTPSection"
    id="carSelectionSingle">
    <div class="cst-input-field">
      <label translate class="mbt5">lblYourCarDetails</label>
      <div class="row">
        <div class="col-70 xscol-100 smcol-100 mdcol-60">
          <ul class="all-dealer-listing height-auto mbt15 noradio">
            <li class="cst-grey-box">
              <label class="cst-radio selected selected-row d-flex aling-items-center">
                <div class="cst-distance-info brand-logo-left flex-center">
                  <img af-brand-logo [data-code]="vehicleCustomerDetailsSingle?.makeCode?.toUpperCase()" data-type="BRAND" width="40" [alt]="vehicleCustomerDetailsSingle?.makeCode" />
                </div>
                <div class="car-details flex-grow">
                  <h3 class="font18">{{vehicleCustomerDetailsSingle.makeName}}<span> | </span>
                    {{vehicleCustomerDetailsSingle.model}}</h3>
                  <div translate class="d-flex aling-items-center">
                    <div class="lic-plate-small d-flex aling-items-center">
                      <em class="cmn-icn icn-small-flag mr-1"></em>
                      <span class="fw-bold">{{vehicleCustomerDetailsSingle.licensePlate}}</span>
                    </div>
                    <span *ngIf="vehicleCustomerDetailsSingle.year > 0" class="border-sep mx-25"></span>
                    <span *ngIf="vehicleCustomerDetailsSingle.year > 0" class="d-flex aling-items-center">
                      <em class="fa fa-500 fa-calendar-alt fs18px fas mr-2"></em><span
                        class="medium font-18">{{vehicleCustomerDetailsSingle.year}}</span>
                    </span>
                  </div>
                </div>
                <input type="radio" ngModel #radio="ngModel" name="singlecar" [value]=1 checked />
                <span class="radioface listRadio"></span>
              </label>
            </li>
          </ul>
          <div class="clearfix"></div>
        </div>
      </div>


      <div class="row">
        <div class="col-100">
          <div class="btn-grp fright xsmbt10">
            <button translate class="btn smallbtn fleft" id="showRegPhoneNumber" aria-label="Center Align"
              (click)="setValuesAndNavigate()" type="submit">
              lblNext <em class="pos-relative font18 fa fa-angle-right mr-2"></em>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="pos-relative mtp-70 xs-mtp20" *ngIf="sections.carSelectionMultiple && !showTempOTPSection"
    id="carSelectionDouble">

    <h4 translate class="title-h4 mbt10">lblYourCarDetails</h4>
    <p translate class="mbt10" *ngIf="iscar">
      lblWeFoundTheFollowingCarAssociatedWithMobilenNo
    </p>
    <p translate class="mbt10" *ngIf="!iscar">
      lblCarAssociatedWithMobilenNoNotFound
    </p>
    <div class="row">
      <div class="col-70 xscol-100 smcol-100 mdcol-80">
        <form [formGroup]="multipleCarSelectionForm" (ngSubmit)="onMultipleCarSelectionFormSubmit()">
          <ul class="all-dealer-listing height-auto mbt15" *ngIf="iscar">
            <li class="cst-grey-box" *ngFor="let car of existingVehicleCustomerDetails; let i= index">
              <label for="{{i}}" class="cst-radio d-flex aling-items-center"
                [class.selected-row]="multipleCarSelectionForm.controls.selectedCar.value == i">
                <div class="cst-distance-info flex-center">
                  <img af-brand-logo [data-code]="car.companyMakeCode?.toUpperCase()" data-type="BRAND" width="40" [alt]="car.companyMakeName" />
                </div>
                <div class="car-details flex-grow">
                  <h3 class="font18">{{car.companyMakeName}} | {{car.companyModel}}</h3>
                  <div translate class="d-flex aling-items-center">
                    <div class="lic-plate-small d-flex aling-items-center">
                      <em class="cmn-icn icn-small-flag mr-1"></em>
                      <span class="fw-bold">{{car.licensePlateNo}}</span>
                    </div>
                    <span *ngIf="car.year > 0" class="border-sep mx-25"></span>
                    <span *ngIf="car.year > 0" class="d-flex aling-items-center">
                      <em class="fa fa-500 fa-calendar-alt fs18px fas mr-2"></em><span
                        class="medium font-18">{{car.year}}</span>
                    </span>
                  </div>
                </div>
                <input type="radio" name="selectedCar" (click)="onSelectCar($event,i)" [id]="i" [value]="i" formControlName="selectedCar" />
                <span class="radioface listRadio" ></span>
              </label>
            </li>
          </ul>

          <div class="d-flex">
          <div class="btn-grp mb xsmbt10 text-left">
            <button *ngIf="isAddCarAllowed" class="btn btn-primary mb-1 mr-1" type="button" translate
                  (click)="onAddCar()" value="Next" [disabled]="multipleCarSelectionForm.valid">
                  lblAddCar
            </button>
            <button class="btn btn-secondary mb-1 " aria-label="Center Align" value="Next" type="button" translate
              (click)="ChangePhoneNoBack()" [disabled]="multipleCarSelectionForm.valid">
              lblChangePhoneNumber
            </button>

          </div>

          <div class="mb text-right ml-auto" *ngIf="existingVehicleCustomerDetails.length>0">

            <button class="btn next-btn ml-1" aria-label="Center Align" translate
              [disabled]="!multipleCarSelectionForm.valid" type="submit" value="Next">
              lblNext
            </button>
          </div>

        </div>

          <div class="clearfix"></div>
        </form>
      </div>
    </div>
  </div>
  <div class="row xsmbt0" style="margin-top:30px" *ngIf="showLPSearch">
    <div class="col-100">
      <div class="cst-input-field medium input-with-icn mb-1">
        <label translate>lblEnterRegNoOrVinNo</label>
      </div>
    </div>
    <div class="col-50 xscol-100 mbt15">
      <div class="cst-input-field big input-with-icn">
        <div class="lic-plate pos-relative">
          <em class="cmn-icn icn-flag  " [ngClass]="licensePlateClass"></em>
          <input type="text" id="regNo" class="pdl60 bold fs20px" [(ngModel)]="vehicleNo" (ngModelChange)="vehicleNo = $event.toUpperCase()" [appAutoFocus] (keyup.enter)="showVehicleDetails(true)">
          <button type="button" class="btn btn-primary m-1" translate (click)="showVehicleDetails(true)">
            lblSearch
          </button>
        </div>

      </div>
    </div>
    <div class="col-auto xscol-100 mbt15 top-margin text-right">
       <button type="button" class="btn btn btn-primary mt-2" translate (click)="showVehicleDetails(false)" >
        lblAddCarManually
      </button>
    </div>
    <div class="col-100">
      <div class="hr-lineborder"></div>
    </div>
  </div>
</div>
</ng-template>